import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

function linearGradient(fillColor) {
  return `linear-gradient(135deg, ${fillColor} 20%, #ffffff 20%, #ffffff 40%, ${fillColor} 40%, ${fillColor} 60%, #ffffff 60%, #ffffff 80%,  ${fillColor} 80%, #ffffff 100%)`
}

//TODO: Similar to KpiBarChartTooltip. Refactor?
const ProductDischargeTooltip = props => {
  const { active, payload = [], label, productColors } = props
  if (!active || isEmpty(payload)) {
    return null
  }

  return (
    <div className="kpi-tooltip box-element">
      <p className="bold">{label}</p>
      <hr />
      {payload.map(data => (
        <div className="item-list" key={data.name}>
          <div
            className="inline"
            style={{
              borderRadius: '5px',
              // Cell fill doesn't populate color property in payload
              background: data.dataKey === 'averageSpeed' ? productColors[label] : linearGradient(productColors[label]),
              marginRight: '3px',
              height: '10px',
              width: '10px'
            }}
          />
          <div className="inline">
            <span className="bold"> {data.name}: </span>
            {`${data.value || 'N/A'}`}
          </div>
        </div>
      ))}
    </div>
  )
}

ProductDischargeTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  productColors: PropTypes.object
}

export default ProductDischargeTooltip
